






































import Vue from 'vue'
import { IAutoResponse, IItemForSelection } from '@/api/types/response.types'

export default Vue.extend({
  name: 'MailboxSettingsAutoResponderResponse',

  props: {
    index: {
      type: Number,
      default: 0,
    },
    autoResponse: {
      type: Object as () => IAutoResponse,
      required: true,
    },
    useCaseTypes: {
      type: Array as () => IItemForSelection[],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    edit(): void {
      this.$emit('edit', this.index)
    },
    remove(): void {
      this.$emit('remove', this.index)
    },
    getUseCaseName(id: number): string {
      return this.useCaseTypes.find(u => u.id === id).name
    },
    hasAnyUseCases(autoResponse: IAutoResponse): boolean {
      return autoResponse.listUseCaseTypeIDs.length > 0
    },
    hasAllUseCases(autoResponse: IAutoResponse): boolean {
      return !this.useCaseTypes.find(
        u => !autoResponse.listUseCaseTypeIDs.includes(u.id),
      )
    },
    hasNoUseCases(autoResponse: IAutoResponse): boolean {
      return !this.hasAnyUseCases(autoResponse)
    },
  },
})
